var map = {
	"./AffideaPoland": [
		"2642",
		"chunk-35d542bf",
		"chunk-2d0b2cb8"
	],
	"./AffideaPoland.vue": [
		"2642",
		"chunk-35d542bf",
		"chunk-2d0b2cb8"
	],
	"./NHSEastLancashire": [
		"86a5",
		"chunk-35d542bf",
		"chunk-0c61445c"
	],
	"./NHSEastLancashire.vue": [
		"86a5",
		"chunk-35d542bf",
		"chunk-0c61445c"
	],
	"./UK": [
		"dd2e",
		"chunk-35d542bf",
		"chunk-77eb2bb2"
	],
	"./UK.vue": [
		"dd2e",
		"chunk-35d542bf",
		"chunk-77eb2bb2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3e8b";
module.exports = webpackAsyncContext;